/**
 * 最近交易记录模块
 */
import { Module } from 'vuex'
import { LatestPaymentRecordsState } from './types'
import { FetchStatus, RootState } from '../types'

enum mutationTypes {
  UPDATE_RECORDS = 'UPDATE_RECORDS',
  UPDATE_FETCH_STATUS = 'UPDATE_FETCH_STATUS',
}

const initialState: LatestPaymentRecordsState = {
  fetchStatus: FetchStatus.NONE,
  // 不会缓存列表数据，所以此处不使用 paymentCode 作为索引
  records: [],
}

export const latestPaymentRecords: Module<LatestPaymentRecordsState, RootState> = {
  namespaced: true,
  state: initialState,
  actions: {
    /**
     * 获取最近 30 天交易记录
     */
    async fetchLatestPaymentRecords({ state, commit }, paymentCode?: string): Promise<void> {
      if (state.fetchStatus === FetchStatus.LOADING) {
        return
      }

      if (!paymentCode) {
        throw new Error('商户信息不存在，请扫描正确的二维码')
      }

      try {
        commit(mutationTypes.UPDATE_FETCH_STATUS, FetchStatus.LOADING)

        const list = await API.payment.latestPaymentList.request({
          paymentCode,
        }) as defs.PaymentUserResultDto[]

        if (!list.length) {
          throw new Error('最近 30 天内暂无交易')
        }

        commit(mutationTypes.UPDATE_RECORDS, list)
        commit(mutationTypes.UPDATE_FETCH_STATUS, FetchStatus.LOADED)
      } catch (error) {
        commit(mutationTypes.UPDATE_FETCH_STATUS, FetchStatus.FAILED)

        throw error
      }
    },
  },
  mutations: {
    [mutationTypes.UPDATE_RECORDS](state, records: defs.PaymentUserResultDto[]): void {
      state.records = records
    },
    [mutationTypes.UPDATE_FETCH_STATUS](state, status: FetchStatus): void {
      state.fetchStatus = status
    },
  },
}
